import React from 'react'

import { Input } from 'antd'
import { useField, useFormikContext } from 'formik'

import Label from '../components/Label'
import FieldProps from './FieldProps'
import Error from './FormItemError'

import './FormikStyles.less'

interface InputNumberProps extends FieldProps {
  defaultValue?: number
  autoFocus?: boolean
  disabled?: boolean
  min?: number
  max?: number
  prefix?: string
  suffix?: string
  precision?: number
  decimalSeparator?: string
  step?: number | string
  onPressEnter?: React.KeyboardEventHandler<HTMLInputElement>
  hint?: string
  formatter?: (value: number | string | undefined) => string
  parser?: (displayValue: string | undefined) => number | string
}

const FormikDefaultInputSearchField: React.FC<InputNumberProps> = (props) => {
  const [field, meta] = useField(props)
  const { setFieldValue } = useFormikContext()
  const showError = meta.touched && meta.error
  const error = showError ? <Error>{meta.error}</Error> : <Error></Error>
  const id = props.id || props.name

  const onChange = (value) => {
    setFieldValue(props.name, value.target.value)
    if (props.onChange) {
      // @ts-ignore
      props.onChange(value)
    }
  }

  const hint = props.hint ? <span className="formik-field__span"> {props.hint}</span> : null

  return (
    <>
      <Label htmlFor={id} className=" no-select hand-on-hover">
        {props.label}
        {hint}
      </Label>
      <Input {...field} {...props} id={id} onChange={onChange} />
      {error}
    </>
  )
}

export default FormikDefaultInputSearchField
